import { SVGProps } from '@components/Icon/types';

export const AddFolder = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(2, 3)">
      <path
        d="M10.0958 6.9156C10.4637 6.91583 10.7626 7.2129 10.7626 7.57895V10.1361H13.1427L13.2775 10.15C13.581 10.2119 13.8093 10.4793 13.8095 10.7994C13.8095 11.1657 13.5109 11.4628 13.1427 11.4628H10.7626V13.8312L10.7487 13.9654C10.6864 14.2673 10.4177 14.4944 10.0958 14.4946C9.72761 14.4946 9.42894 14.1975 9.42894 13.8312V11.4628H6.85733C6.48914 11.4628 6.19048 11.1657 6.19048 10.7994C6.19075 10.4334 6.48931 10.1361 6.85733 10.1361H9.42894V7.57895C9.42902 7.21276 9.72765 6.9156 10.0958 6.9156Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.74293 0C7.29893 0 7.82731 0.241594 8.18917 0.661493L10.1907 2.98458C10.3716 3.19456 10.6362 3.31579 10.9142 3.31579H16.1905C18.2944 3.31579 20 5.01239 20 7.10526V14.2105C20 16.2379 18.3995 17.8938 16.3867 17.9954L16.1905 18H3.80952C1.70558 18 1.53394e-08 16.3034 0 14.2105V3.78947C0 1.69661 1.70558 0 3.80952 0H6.74293ZM3.80952 1.32669C2.44196 1.32669 1.33371 2.42911 1.33371 3.78947V14.2105C1.33371 15.5709 2.44196 16.6733 3.80952 16.6733H16.1905C17.558 16.6733 18.6663 15.5709 18.6663 14.2105V7.10526C18.6663 5.7449 17.558 4.64248 16.1905 4.64248H10.9142C10.247 4.64248 9.613 4.35171 9.17876 3.84776L7.17727 1.52467C7.06871 1.39868 6.90975 1.32669 6.74293 1.32669H3.80952Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'addFolder';
